import __request__ from 'routing/request';
interface AthenaConnectionCredentials {
    readonly aws_region: string;
    readonly data_lake_name: string;
    readonly stream_id: string;
    readonly aws_access_key: string;
    readonly aws_iam_role: string;
    readonly id: string;
    readonly aws_secret_key: unknown;
    readonly s3_output_bucket: string;
}
type stringArray = string[];
interface AthenaCredentialsRequest {
    readonly aws_region: string;
    readonly data_lake_name: string;
    readonly stream_id: string;
    readonly stream_title: string;
    readonly aws_access_key: string;
    readonly stream_description: string;
    readonly aws_iam_role: string;
    readonly id: string;
    readonly aws_secret_key: unknown;
    readonly s3_output_bucket: string;
}
type AthenaConnectionCredentialsArray = AthenaConnectionCredentials[];
interface AthenaCredentialsSaveResult {
    readonly id: string;
}
/**
 * Get all available Athena connection credentials
 */
export function listCredentials(): Promise<AthenaConnectionCredentialsArray> {
    return __request__('GET', '/plugins/org.graylog.plugins.datalake/athena/credentials', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get IDs of all available AWS regions
 */
export function listRegions(): Promise<stringArray> {
    return __request__('GET', '/plugins/org.graylog.plugins.datalake/athena/credentials/regions', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create or update Athena connection credentials
 */
export function save(JSONbody: AthenaCredentialsRequest): Promise<AthenaCredentialsSaveResult> {
    return __request__('POST', '/plugins/org.graylog.plugins.datalake/athena/credentials/save', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Delete Athena credentials
 */
export function deleteCredentials(id: string): Promise<void> {
    return __request__('DELETE', `/plugins/org.graylog.plugins.datalake/athena/credentials/${id}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get Athena connection credentials by their ID
 */
export function credentialDetails(id: string): Promise<AthenaConnectionCredentials> {
    return __request__('GET', `/plugins/org.graylog.plugins.datalake/athena/credentials/${id}`, null, {}, {
        'Accept': ['application/json']
    });
}
